import React from 'react';
import Welcome from './Welcome';
import { useNavigationContext } from '../../../contexts/NavigationContext';
import Navbar from '../common/navbar/Navbar';
import EventPage from './Events/EventPage';
import InternalResourcePage from './InternalResources/InternalResourcesPage';
import ExternalResourcePage from './ExternalResources/ExternalResourcesPage';

function Home() {
  const { navigationContext } = useNavigationContext();

  return (
    <div className="flex flex-row h-screen w-screen">
      <div className="min-w-64 w-64">
        <Navbar />
      </div>
      <div className="w-full h-auto overflow-scroll">
        <EventPage isActive={navigationContext.acitveAppKey === 'syevent'} />
        <InternalResourcePage isActive={navigationContext.acitveAppKey === 'syinternalresource'} />
        <ExternalResourcePage isActive={navigationContext.acitveAppKey === 'syexternalresource'} />

        <Welcome isActive={!navigationContext.acitveAppKey} />
      </div>
    </div>
  );
}

export default Home;
